import request from '@/utils/requestV2'
const qs = require('qs')

// 获取任务附件历史列表
export function getTaskAttachList (data) {
  return request({
    url: '/ooh-msp/v2/task/gettaskattachlist',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 保存任务附件记录
export function addTaskAttach (data) {
  return request({
    url: '/ooh-msp/v2/task/addtaskattach',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除任务附件
export function deleteTaskAttach (data) {
  return request({
    url: '/ooh-msp/v2/task/deletetaskattach',
    method: 'post',
    data: qs.stringify(data)
  })
}
